import styled from '@emotion/styled';
import Skeleton from 'components/base/Skeleton';
import Ratio from 'components/toolbox/croquis/core/Ratio';

/**
 * 찜 > 최근 본 상품 캐러셀 > 스켈레톤
 * @component
 */
const RecentProductCarouselSkeleton = () => {
  return (
    <SC.Container>
      <Ratio width={83} height={83}>
        <Skeleton radius={2} />
      </Ratio>
    </SC.Container>
  );
};

export default RecentProductCarouselSkeleton;

const SC = {
  Container: styled.li`
    flex: 0;
    cursor: pointer;
    margin-right: 4px;
    min-width: 83px;
  `,
};
